import type { Recipe, RecipeStatus } from "@/lib/api/building";

// A recipe is "active" only while applied or scheduled — a pending / simulated / superseded recipe
// must never be shown as 'Aktiivinen resepti' (its simulated_impact is null, so the card would show
// '—'). #195.
export const ACTIVE_RECIPE_STATUSES: ReadonlySet<RecipeStatus> = new Set([
  "applied",
  "scheduled",
]);

// The newest **active** recipe, or null if none is active — not merely the newest recipe.
export function pickActiveRecipe(recipes: Recipe[]): Recipe | null {
  const active = recipes.filter((r) => ACTIVE_RECIPE_STATUSES.has(r.status));
  return active.length > 0
    ? active.reduce((a, b) => (a.created_at > b.created_at ? a : b))
    : null;
}
